"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("../../../graphql");
const CustomError_1 = require("../CustomError");
const roundOff_1 = require("./roundOff");
/**
 * This function calculates the value of `Ms` field which is referred to as the value of `Ps` field in the previous calculation.
 * The calculation is based on the given input parameters and follows a series of formulas.
 * @param param - The input parameters for the calculation.
 * @param param.PA - unit (either "metric" or "us_customary").
 * @param param.PB - desiredMaxAmtForFirstFeeding
 * @param param.PC - desiredMaxAmtForSecondFeeding
 * @param param.PD - igGInColostrumReplacer
 * @param param.PE - birthBodyWt
 * @param param.PG - brixUsedInPrevCalculation
 * @param param.Pi - Calculated value in pooled colostrum replacer calculator
 * @returns The calculated value of `Ms`.
 */
const previousPsValueCalculation = ({ PA, PB, PC, PD, PE, PG, Pi, }) => {
    /**
     * Row Ms calculation
     */
    const Mj = 6.94;
    const Mk = -96.5;
    const MF = PG;
    const MI = Mj * MF + Mk;
    const Mm = MI * 0.94635;
    const Mn = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? Mm : MI;
    const Mo = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary
        ? PE * 1.6666 + 150
        : PE * 2.2046 * 1.6666 + 150;
    if (Mn === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Mn"');
    }
    const My = (0, roundOff_1.default)(Mo / Mn, 1);
    const Mx = My < PB ? 0 : (Mo - PB * Mn) / Mn;
    const MAC = (0, roundOff_1.default)(Mx, 1) > PB ? PB : (0, roundOff_1.default)(Mx, 1);
    const intermediateMnValue = (0, roundOff_1.default)(Mx, 1) > PB ? PB : (0, roundOff_1.default)(Mx, 1);
    const MN = MAC > PC ? PC : intermediateMnValue;
    const Mw = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (PD / 100) * 453 : PD;
    const MAD = MAC + PB - (PB + PC) < 0 ? 0 : MAC + PB - (PB + PC);
    const Mz = My - PB;
    const MAA = Mo - (Mo - Mz * Mn);
    const MAB = MN * Mn;
    const MJ = Pi > PB ? 2 : 1;
    const MAG = (MAA - MAB) / MJ;
    if (Mw === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Mw"');
    }
    const intermediateMAHValue = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary
        ? (0, roundOff_1.default)(MAG / Mw, 2)
        : (0, roundOff_1.default)(MAG / (Mw / 100), 0);
    const MAH = MAD < 0 ? 0 : intermediateMAHValue;
    const MP = MAH > 0 ? MAH : 0;
    const MAF = PC / (PB + PC);
    const MO = (0, roundOff_1.default)(MJ * MP * MAF, 2);
    const Ms = Mn * MN + Mw * MO;
    return Ms;
};
exports.default = previousPsValueCalculation;
//# sourceMappingURL=previousPsValueCalculation.js.map